import React, {useContext, useState} from "react";
import {UserContext} from "../../../Contexts/UserContext";
import {useTranslation} from "react-i18next";
import {ScreenWidthContext} from "../../../Contexts/ScreenWidthContext";
import '../../../Assets/Css/Pages/User/MerchantLimit/List.css';
import Breadcrumb from "../../../Components/Breadcrumb";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ReceiverList from "./Pages/ReceiverList";
import ProductLimitList from "./Pages/ProductLimitList";

export default function MerchantLimit() {
    const {t} = useTranslation();
    const userContext = useContext(UserContext);
    const [lastTabName, setLastTabName] = useState<string>(t('user-page.merchant-limit.tabs.general'));
    const [breadcrumb, setBreadcrumb] = useState<any[]>(
        [
            {name: t('layout.user-menu.merchant-limit'), path: null},
            {name: lastTabName, path: null}
        ]
    );

    if (userContext?.user === null){
        return (<></>);
    }

    return(
        <>
            <Breadcrumb breadcrumb={breadcrumb} />

            <div className={'user-content-box merchant-limit'} >

                <Tabs onSelect={(index: number) => index === 0 ? setLastTabName(t('user-page.merchant-limit.tabs.general')) : setLastTabName(t('user-page.merchant-limit.tabs.products-limit'))} >
                    <TabList>
                        <Tab>
                            <i className="fas fa-users"></i> {t('user-page.merchant-limit.tabs.general')}
                        </Tab>
                        <Tab>
                            <i className="fas fa-list"></i> {t('user-page.merchant-limit.tabs.products-limit')}
                        </Tab>
                    </TabList>

                    <div className="content" >
                        <TabPanel>
                            <ReceiverList setBreadcrumb={setBreadcrumb} />
                        </TabPanel>
                        <TabPanel>
                            <ProductLimitList />
                        </TabPanel>
                    </div>
                </Tabs>
            </div>
        </>
    );
}